import { Close } from "@mui/icons-material";
import { Box, Button, IconButton, styled } from "@mui/material";
import { rem } from "polished";
import React, { useEffect, useRef } from "react";

import { AccountQualityLabels, ariaLabel } from "src/constants";
import { AccountFragment, CustomerFragment } from "src/graphql/generated/types";
import { getCustomerDisplayName } from "src/utils";

import { ContentEstate } from "../ContentStateProps";

type Props = {
  hasSeveralAccounts: boolean;
  account: AccountFragment;
  customer: CustomerFragment;
  toAuth(): void;
  closeSidebar(): void;
  isOpen?: boolean;
};

const StyledRootBox = styled(Box)`
  background: ${(props) => props.theme.palette.common.white};
`;

const StyledHead = styled("div")`
  background-color: ${(props) => props.theme.palette.common.white};
  width: 100vw;
  ${(props) => props.theme.breakpoints.between("sm", "lg")} {
    width: 50vw;
  }
  height: 4rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 ${(props) => props.theme.spacing(2)} 0 0;
`;

const CloseIcon = styled(Close)`
  width: 2rem;
  height: 2rem;
  & path {
    fill: ${(props) => props.theme.palette.secondary.main};
  }
`;

const AccountDetails = styled("div")`
  padding: ${(props) => props.theme.spacing(2)};
  background-color: ${(props) => props.theme.palette.gray.background};
`;

const ContentCustomer = styled("div")`
  border-left: ${rem(3)} solid ${(props) => props.theme.palette.primary.main};
  background-color: ${(props) => props.theme.palette.common.white};
  padding: ${(props) => props.theme.spacing(2)};
  color: ${(props) => props.theme.palette.secondary.main};
  font-size: ${rem(16)};
`;

const CustomerName = styled("div")`
  font-weight: bold;
  text-transform: capitalize;
`;

export const MainLayoutAccountInfosMobile = ({
  hasSeveralAccounts,
  account,
  customer,
  toAuth,
  closeSidebar,
  isOpen = false,
}: Props) => {
  const closeButtonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (isOpen && closeButtonRef.current) {
      closeButtonRef.current.focus();
    }
  }, [isOpen]);
  const buildings =
    account.__typename === "LandlordAccount" ? account.buildings : [account.building];

  return (
    <StyledRootBox>
      <StyledHead>
        <IconButton
          ref={closeButtonRef}
          aria-label={ariaLabel.closeMenuButtonLabel}
          onClick={closeSidebar}
        >
          <CloseIcon />
        </IconButton>
        {hasSeveralAccounts && (
          <Button variant="contained" onClick={toAuth} role="link">
            Changer de compte
          </Button>
        )}
      </StyledHead>
      <AccountDetails>
        <ContentEstate buildings={buildings} />
        <ContentCustomer>
          <CustomerName>{getCustomerDisplayName(customer)}</CustomerName>
          <div>{AccountQualityLabels[account.quality]}</div>
          <div>N° du compte : {account.number}</div>
        </ContentCustomer>
      </AccountDetails>
    </StyledRootBox>
  );
};
